import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TravelRequestState {
  copyData: {
    id: number | null;
    data: any | null;
  };
}

const initialState: TravelRequestState = {
  copyData: {
    id: null,
    data: null,
  },
};

const travelRequestSlice = createSlice({
  name: 'travel',
  initialState,
  reducers: {
    setCopyData: (state, action: PayloadAction<{ id: number; data: any }>) => {
      state.copyData = action.payload;
    },
    clearCopyData: state => {
      state.copyData = {
        id: null,
        data: null,
      };
    },
  },
});

export const { setCopyData, clearCopyData } = travelRequestSlice.actions;

export default travelRequestSlice;
